import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var CollageStaffImg = "/assets/svg/character/college.svg";
export default function CollegeStaff(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 255 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 255 : _ref$width;
  return /*#__PURE__*/_jsx("img", {
    src: CollageStaffImg,
    height: height,
    width: width
  });
}